<template>
    <console-content max-width="1280" class="overflow-visible">
        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">토핑 상품 조회</v-col>
            <v-spacer />
            <v-col cols="auto" class="py-0">
            </v-col>
        </v-row>

        <v-row class="mt-6" align="center">
            <v-col cols="auto" class="pr-2">
                <v-text-field v-model="searchValue" label="토핑 상품코드" dense outlined hide-details />
            </v-col>
            <v-col cols="auto" class="px-0">
                <v-btn color="primary" @click="search()">
                    <span>검색</span>
                </v-btn>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
                <v-btn color="white" class="green--text" @click="excel()">
                    <v-icon left class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>
                    <span>엑셀다운로드</span>
                </v-btn>
            </v-col>
        </v-row>

        <v-simple-table class="elevation-1 mt-2">
            <thead>
                <tr>
                    <th width="100">코드</th>
                    <th width="100">상품명</th>
                    <th width="110">가격</th>
                    <th width="110">교환처</th>
                    <!-- <th width="200">이미지URL</th> -->
                    <th width="400">이용안내</th>
                    <th width="400">상품 상세 설명</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="product, index in products" :key="index">
                    <td>{{ product.id }}</td>
                    <td>{{ product.title }}</td>
                    <td>{{ product.price }}</td>
                    <td>{{ product.use_area }}</td>
                    <!-- <td>{{ imageUrl(product.images) }}</td> -->
                    <td><div v-html="product.policy_expextend"></div></td>
                    <td><div v-html="product.content"></div></td>
                </tr>
            </tbody>
        </v-simple-table>
    </console-content>
</template>

<script>
import XLSX from "xlsx";
import api from "@/api";
import ConsoleContent from "@/pages/console/templates/ConsoleContent.vue";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
        ConsoleContent,
    },
    data() {
        return {
            mdiMicrosoftExcel,

            searchValue: null,

            products: []
        };
    },
    mounted() {
    },
    methods: {
        async search(){
            if(!this.searchValue){
                alert("토핑 상품코드를 입력해주세요");
                return;
            }

            this.products = [];
            this.searchValue.split(",").forEach((productId) => {
                this.products.push({
                    productId,
                });
            });

            for(let index in this.products){
                // if((+index+1) % 3 == 0) await this.sleep();
                let { product } = await api.console.platforms.topping.get({
                    params: {
                        ...this.products[index],
                    }
                });

                this.$set(this.products, index, {
                    ...this.products[index],
                    ...product
                });
            }
        },
        sleep(){
            return new Promise((resolve) => {
                setTimeout(() => resolve(), 1000);
            });
        },
        imageUrl([image]){
            if(!image) return;

            return image.imageUrl.split("|").map(path => `https://proxy.bizpopcon.link/image` + path).join(',');
        },
        async excel() {
            if(!this.products.length){
                alert("조회를 먼저 해주세요");
                return;
            }

            var datas = [];
            this.products.forEach((product) => {
                datas.push({
                    "코드": product.productId,
                    "상품명": product.title,
                    "가격": product.price,
                    "교환처": product.use_area,
                    "이미지URL1": product.img1,
                    "이미지URL2": product.img2,
                    "이용안내": product.policy_expextend,
                    "상품 상세 설명": product.content
                });
            });

            var workbook = new XLSX.utils.book_new();
            var worksheet = XLSX.utils.json_to_sheet(datas);

            XLSX.utils.book_append_sheet(workbook, worksheet, "토핑 상품 조회");
            XLSX.writeFile(workbook, "토핑 상품 조회.xlsx");
        },
    },
};
</script>